module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/monza.fc263aacb53982858674680522062ad3.jpg";